import { render, staticRenderFns } from "./OnboardingWrapper.vue?vue&type=template&id=259151bb"
import script from "./OnboardingWrapper.vue?vue&type=script&lang=js"
export * from "./OnboardingWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports